import { IFieldType, IFormSchema } from "shared/types";
import { copy } from "shared/assets";
import {
  IEquipmentCategoryItem,
  IEquipmentSubcategoryItem,
} from "Venues/types";

const {
  form,
  editEquipment: { addMoreInfo },
} = copy;

export const makeSchema = (
  category: IEquipmentCategoryItem | IEquipmentSubcategoryItem,
  closeForm?: () => void
): IFormSchema => ({
  fields: [
    {
      title: `${addMoreInfo.title} ${category.label}`,
      name: category.category,
      hideContainer: true,
      fields: [
        {
          type: IFieldType.rte,
          name: "text",
          label: addMoreInfo.label,
          hideLabel: true,
        },
      ],
    },
  ],
  defaultValues: {
    [category.category]: {
      text: category.text || "",
    },
  },
  buttons: {
    primary: {
      children: form.save,
      size: "m",
      "data-testid": `save_${category.category}`,
    },
    secondary: {
      size: "m",
      ...(closeForm && { onClick: closeForm }),
    },
  },
});
